export const selectClaimsActiveFilters = (state) => state.filters?.claimsActiveFilters;
export const selectRisksActiveFilters = (state) => state.filters?.risksActiveFilters;
export const selectPoliciesActiveFilters = (state) => state.filters?.policiesActiveFilters;
export const selectReportingActiveFilters = (state) => state.filters?.reportingActiveFilters;
export const selectReportingRiskOutliersSortingParameter = (state) =>
  state.filters?.reportingRiskOutliersSortingParameter;

export const selectRisksSortingParameter = (state) => state.filters?.risksSortingParameter;
export const selectIsFiltersDrawerOpen = (state) => state.filters?.isFiltersDrawerOpen;

export const selectClaimsHousingStocksFilterOptions = (state) => state.filters?.claimsHousingStocksFilterOptions;
export const selectClaimsInsuredRisksFilterOptions = (state) => state.filters?.claimsInsuredRisksFilterOptions;
export const selectClaimsInsuredRiskTypesFilterOptions = (state) => state.filters?.claimsInsuredRiskTypesFilterOptions;
export const selectClaimsCreatedByOrganizationsFilterOptions = (state) =>
  state.filters?.claimsCreatedByOrganizationsFilterOptions;
export const selectClaimsOrganizationsWithAccessFilterOptions = (state) =>
  state.filters?.claimsOrganizationsWithAccessFilterOptions;

export const selectPoliciesHousingStocksFilterOptions = (state) => state.filters?.policiesHousingStocksFilterOptions;
export const selectPoliciesInsuranceOrganizationsFilterOptions = (state) =>
  state.filters?.policiesInsuranceOrganizationsFilterOptions;
export const selectPoliciesCustomFieldsFilterOptions = (state) => state.filters?.policiesCustomFieldsFilterOptions;
export const selectPoliciesInsuredRisksFilterOptions = (state) => state.filters?.policiesInsuredRisksFilterOptions;
export const selectPoliciesInsuredRiskTypesFilterOptions = (state) =>
  state.filters?.policiesInsuredRiskTypesFilterOptions;

export const selectRisksHousingStocksFilterOptions = (state) => state.filters?.risksHousingStocksFilterOptions;
export const selectRisksOrganizationsFilterOptions = (state) => state.filters?.risksOrganizationsFilterOptions;
export const selectRisksCompanyLabelsFilterOptions = (state) => state.filters?.risksCompanyLabelsFilterOptions;
export const selectRisksCompanyCodesFilterOptions = (state) => state.filters?.risksCompanyCodesFilterOptions;
export const selectRisksEconomicUnitsFilterOptions = (state) => state.filters?.risksEconomicUnitsFilterOptions;

const FILTERS_KEY_MAP = {
  claims: selectClaimsActiveFilters,
  policies: selectPoliciesActiveFilters,
  risks: selectRisksActiveFilters
};

export const selectActiveFiltersByType = (state, dataType) => {
  const select = FILTERS_KEY_MAP[dataType];
  return select ? select(state) : '';
};
